import { useChatContext } from 'stream-chat-react';

import { useStore } from '@common/components/StoreProvider';

/**
 * Finds a user in a chat based on the current user ID and the `getSelf` flag.
 *
 * @param getSelf - Boolean flag indicating whether to get the current user (`true`)
 * 														or the other user (`false`).
 * @returns The member object representing the requested user, or `undefined` if not found.
 */

function useGetUser(getSelf = false) {
	const { profile } = useStore();
	const { channel } = useChatContext();

	if (!channel) return undefined;

	const { id: currentUserId } = profile;

	const members = channel.state?.members;

	// eslint-disable-next-line no-confusing-arrow
	return Object.values(members)?.find((member) =>
		getSelf ? member.user_id === String(currentUserId) : member.user_id !== String(currentUserId),
	);
}

export default useGetUser;
